import { render, staticRenderFns } from "./ContactTwoContactListDialogue.vue?vue&type=template&id=1ce1327d&scoped=true&"
import script from "./ContactTwoContactListDialogue.vue?vue&type=script&lang=ts&"
export * from "./ContactTwoContactListDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./ContactTwoContactListDialogue.vue?vue&type=style&index=0&id=1ce1327d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1327d",
  null
  
)

export default component.exports